<header class="header d-flex align-items-center justify-content-between">
    <div class="logo"><img src="assets/images/logo.svg" alt=""></div>
    <div class="rightprt d-flex align-items-center">
        <button mat-raised-button class="noticon"><img src="/assets/images/bell.svg" alt=""></button>
        <button mat-raised-button class="userlogin"><img src="{{userInfo?.userImagePath ? userInfo?.userImagePath : 'assets/images/userLogo.png'}}" alt=""> <span
                class="name">{{userInfo?.userName}} </span></button>
    </div>
</header>